import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';
export const getAttributeFunc = createAsyncThunk("get attribute function", async (id, thunkAPI) => {
  try {
    const response = await api.get(`/dashboard/attributes/${id}`);
    return response.data.data.attribute;;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message);
  }
});

const getAttributeSlicer = createSlice({
  name: "get attribute slicer",
  initialState: {
    loading: false,
    data: null,
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getAttributeFunc.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.apiErrors = {};
    })
      .addCase(getAttributeFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";

      })
      .addCase(getAttributeFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
        state.data = null;
      });
  }
});

export default getAttributeSlicer.reducer;
